import(/* webpackMode: "eager" */ "/vercel/path0/components/CallAction/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Footer/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/layout.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/GlobalHead/GoogleAds.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Header/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fortawesome/fontawesome-free/css/all.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/vercel/path0/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/fonts.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/reset.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/main.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/utilities.css");
